import * as React from "react";
import { Box } from "@mui/system";
import { commonState } from "../../../store";
import { DriverShiftsView } from "./DriverShiftsView";
import { DetailReportState } from "./store";
import { WeeklyReportState } from "../store";
import * as service from "../../../services/weekly/weeklyreport";
import { colors, fontSizes } from "../../../theme";
import { HermesSnackbar } from "../../../components/snackbar";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import { useHistory } from "react-router-dom";
import { TransitionProps } from "@mui/material/transitions";
import { CurrentDriverHeaderView } from ".";
import { getSessionCookie } from "../../../components/cookies";

const slideTransitionMSec = 700;
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
) {
    return (
        <Slide
            direction="up"
            ref={ref}
            {...props}
            timeout={slideTransitionMSec}
        />
    );
});
interface Props {
    open: boolean;
    setClose: any;
    common: commonState;
    weeklyreport: WeeklyReportState;
    weeklydetail: DetailReportState;
}

export const ShiftsModal: React.FC<Props> = (props: Props) => {
    const handleClose = () => {
        service.resetSelectedDriverDetailInfo();
        props.setClose();
        service.selectWeeklyReports();
    };
    const history = useHistory();
    React.useEffect(() => {
        history.listen((location, action) => {
            if (action === "POP") {
                handleClose();
            }
        });
    }, [props.open]);

    return (
        <Box
            style={{
                display: "flex",
                width: "100%",
                height: "100%",
            }}
        >
            <Dialog
                fullScreen
                fullWidth
                open={props.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                sx={{
                    "& .MuiDialog-paper": {
                        width: "100%",
                    },
                }}
            >
                <Box
                    id="StyledModal-outer"
                    sx={{
                        width: "100%",
                        height: "100%",
                        overflowY: "auto",
                        backgroundColor: "white",
                    }}
                >
                    <Box
                        id="StyledModal-inner"
                        sx={{
                            width: "fit-content",
                            display: "flex",
                            height: "100%",
                        }}
                    >
                        <Box
                            id="close-modal-control"
                            sx={{
                                position: "fixed",
                                right: "90px",
                                zIndex: 3001,
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                window.history.pushState(
                                    "modal",
                                    "Modal",
                                    "/weekly_report"
                                );
                                handleClose();
                            }}
                        >
                            <Box
                                sx={{
                                    displayPrint: "none",
                                    backgroundColor: colors.gray.main,
                                    position: "fixed",
                                    width: "max-content",
                                    p: 2,
                                    display: "flex",
                                    zIndex: 3000,
                                    color: colors.white.main,
                                    fontSize: fontSizes.normal,
                                    borderRadius: "0px 0px 0px 4px",
                                }}
                            >
                                <CloseIcon sx={{ ml: 1, mr: 1 }} /> 閉じる
                            </Box>
                        </Box>
                        <Box
                            id="current-driver-header-wrapper"
                            sx={{
                                mb: 3,
                                backgroundColor: colors.white.main,
                                width: "100%",
                            }}
                        >
                            <CurrentDriverHeaderView {...props} />
                            <DriverShiftsView
                                weeklydetail={props.weeklydetail}
                                permissions={
                                    getSessionCookie().consoleUserPermissions
                                }
                            />
                        </Box>
                        <HermesSnackbar
                            open={props.common.snackbarToggled}
                            msg={props.common.snackbarMsg}
                        />
                    </Box>
                </Box>
            </Dialog>
        </Box>
    );
};
